/*
 * Created by Rodrigo Ali on June 2019.
 */

angular.module('CarsSaraBo').controller('SpecialOfferUpgradeController', [
  '$scope', '$routeParams', '$translate', '$location', '$q',
  'PointOfSaleService', 'ItemSelectorService', 'SitesService', 'FleetUpgradeService', 'CompanyService', 'NotificationService',
  'SpecialOfferService', 'SpecialOfferUrlsService', 'DateService', 'HotjarService', 'GAService',
  function (
      $scope, $routeParams, $translate, $location, $q,
      pointOfSaleService, itemSelectorService, sitesService, fleetUpgradeService, companyService, notificationService,
      specialOfferService, specialOfferUrlsService, dateService, hotjarService, gaService) {

    var sectionSize = 6;
    
    $scope.initialize = function () {
        $scope.upgradeCategories = [];
        $scope.validationErrors = [];
        $scope.carsList = {};
        $scope.pointsOfSaleSelector = {};
        $scope.sitesSelector = {};
        $scope.sitesResponse = {};
        $scope.minBookedDaysOptions = generateBookingLengthArray();
        $scope.maxBookedDaysOptions = generateBookingLengthArray();
        $scope.companyOid = $routeParams.companyOid;
        $scope.selectedUpgrade = {
            prev: {
                left: {},
                right: {}
            },
            current: {
                left: {},
                right: {}
            }
        };
        $scope.activeUpgrade = {
            selected: null
        };

        $scope.isBriefingExpanded = false;
        $scope.isPurchaseWindowEnabled = false;
        $scope.isBookingWindowEnabled = false;
        $scope.isUpgradeToDisabled = true;
        $scope.reservationDayType = {
            MIN: 'minBookedDays',
            MAX: 'maxBookedDays'
        };
        $scope.modificateDayType = {
            SUBSTRACT: 'substract',
            ADD: 'add'
        };
        $scope.sectionDots = {
            left: [],
            right: []
        };
        $scope.channelsList = [
            {value: 'WEBSITE', selected: false},
            {value: 'APPMOBILE', selected: false}
        ];

        $scope.specialOffer = {
            pointsOfSale: [],
            sites: [],
            channels: [],
            cars: [],
            upgradeCar: {},
        };

        getCarUpgrades();

        companyService.get({oid: $routeParams.companyOid}, function (response) {
            $scope.isInternational = (response.tradingType === 'INTERNATIONAL');
            componentAction();
        });
    };

  /*Carousel Component logic related fns*/
    var dotsQtyTrack = {
        left: 0,
        right: 0
    };

    var getDotsQty = function (position) {
        var totalDotsQty = ($scope.selectedUpgrade.current) ? 
            Math.ceil($scope.carsList[$scope.selectedUpgrade.current[position]].length / sectionSize) : [];

        $scope.sectionDots[position] = new Array(totalDotsQty).fill(false).map(function(index) {
            return {
                id: dotsQtyTrack[position] += 1,
                isActive: false
            }
        });
        $scope.sectionDots[position][0].isActive = true;

        dotsQtyTrack.left = 0;
        dotsQtyTrack.right = 0;
    };

    var updateCarouselViewStatus = function () {
        var currentUpgrade = $scope.selectedUpgrade.current;

        $scope.hideLeftCarousel = (currentUpgrade) ? 
            $scope.carsList[currentUpgrade.left].length > sectionSize : !!currentUpgrade;
        $scope.hideRightCarousel = (currentUpgrade) ?
            $scope.carsList[currentUpgrade.right].length > sectionSize : !!currentUpgrade;
    };

    $scope.checkAvailabilityUpgradeTo = function () {
        $scope.isUpgradeToDisabled = isListEmpty('left');

        if ($scope.isUpgradeToDisabled) {
            clearRightSelection();
        }
    };

    $scope.selectAll = function () {
        $scope.carsList[$scope.selectedUpgrade.current.left].forEach(function (car) {
            if (!car.selected) car.selected = !car.selected;
        });
        $scope.checkAvailabilityUpgradeTo();
    };

    $scope.unselectAll = function (clearPrev) {
        var upgradeToClear = (clearPrev) ? 'prev' : 'current';

        $scope.carsList[$scope.selectedUpgrade[upgradeToClear].left].forEach(function (car) {
            if (car.selected) car.selected = !car.selected;
        });

        clearRightSelection();
        $scope.isUpgradeToDisabled = true;
    };

    var clearRightSelection = function () {
        $scope.activeUpgrade.selected = null;
        selectedUpgradeHistory = [];
    }

    $scope.updateSelectedUpgradeCategory = function () {
        $scope.selectedUpgrade.prev = $scope.selectedUpgrade.current;
        $scope.unselectAll(true);
        $scope.isUpgradeToDisabled = true;
        $scope.dividedSection = {
            left: getDividedSection('left', 1),
            right: getDividedSection('right', 1)
        };

        updateCarouselViewStatus();

        getDotsQty('left');
        getDotsQty('right');
    };

    $scope.handleSectionArrowClick = function (position, arrowDirection) {
        var currentSectionIndex = $scope.sectionDots[position].findIndex(function(dot) {
            return dot.isActive;
        });
        var newSectionIndex = (arrowDirection === 'next') ? currentSectionIndex + 1 : currentSectionIndex - 1;

        $scope.changeActiveSection(position, newSectionIndex+1);
    };

    $scope.handleRightUpgradeClick = function () {
        selectedUpgradeHistory.push($scope.activeUpgrade.selected);

        if (selectedUpgradeHistory.length > 1) {
            notifyGA('Autos_Promociones', 'Muchos_Autos_Mayores_Upgrade', ['Clicks']);
        }
    };

    $scope.handleViewMoreClick = function () {
        notifyGA('Autos_Promociones', 'Ver_Tutorial_Upgrade', ['Click']);
        $scope.isBriefingExpanded = true;
    };

    $scope.changeActiveSection = function (position, sectionId) {
        unselectDots(position);
        selectActiveSection(position, sectionId);
    };

    var unselectDots = function (position) {
        $scope.sectionDots[position].forEach(function(dot) {
            dot.isActive = false;
        });
    };

    var selectActiveSection = function (position, sectionId) {
        var sectionArrayIndex = sectionId - 1;
        var sectionArrayLastIndex = $scope.sectionDots[position].length - 1;

        if( 0 <= sectionArrayIndex && sectionArrayIndex <= sectionArrayLastIndex) {
            $scope.sectionDots[position][sectionArrayIndex].isActive = true;
            $scope.dividedSection[position] = getDividedSection(position, (sectionArrayIndex + 1));
        } else if (0 > sectionArrayIndex) {
            $scope.sectionDots[position][sectionArrayLastIndex].isActive = true;
            $scope.dividedSection[position] = getDividedSection(position, (sectionArrayLastIndex + 1));
        } else {
            $scope.sectionDots[position][0].isActive = true;
            $scope.dividedSection[position] = getDividedSection(position, 1);
        }
    };

    var getDividedSection = function (upgradePosition, sectionId) {
        var upperLimit = sectionId * sectionSize;
        var lowerLimit = upperLimit - sectionSize;
        var upgradeArray = ($scope.selectedUpgrade.current) ? 
            $scope.carsList[$scope.selectedUpgrade.current[upgradePosition]] : [];

        return upgradeArray.slice(lowerLimit, upperLimit);
    };
  /*Carousel Component logic related fns*/

    var selectedUpgradeHistory = [];

    var generateBookingLengthArray = function () {
        var count = 0;
        
        return new Array(30)
	        .fill(0)
            .map(function() {
                return ++count;
            });
    };

    var componentAction = function () {
        $scope.showProgressBar();

        if($routeParams.clone) {
            var clonedChannels;
            var clonedUpgradedCars;

            specialOfferService.fetch($scope.companyOid, $routeParams.clone)
                .then(function (response) {
                    $scope.specialOffer = response;

                    delete $scope.specialOffer.oid;
                    delete $scope.specialOffer.version;

                    $scope.specialOffer.validityPeriod = dateService.periodToDate(response.validityPeriod);
                    $scope.specialOffer.bookingWindow = dateService.periodToDate(response.bookingWindow);
                    $scope.specialOffer.minBookedDays = response.minBookedDays || 1;
                    $scope.specialOffer.maxBookedDays = response.maxBookedDays || 1;
                    $scope.specialOffer.approvalStatus = 'PENDING';

                    $scope.isPurchaseWindowEnabled = !!response.bookingWindow;
                    $scope.isBookingWindowEnabled = !!(response.minBookedDays && response.maxBookedDays);

                    $scope.isUpgradeToDisabled = false;
                    clonedChannels = response.channels;
                    clonedUpgradedCars = {
                        left: response.cars,
                        right: response.upgradeCar
                    };

                    getPointsOfSale(function () {
                        if($scope.isInternational){
                            getSites();
                        } else{
                            $scope.hideProgressBar();
                        }
                    });

                    setClonedChannels(clonedChannels);
                    setClonedCarsCategory(clonedUpgradedCars.right.carModel.category);
                    setClonedCarsSelection(clonedUpgradedCars);
                    setClonedActiveSection(clonedUpgradedCars);
            });
        } else {
            getPointsOfSale(function () {
                getSites();
            });
        }
    };

    var setClonedChannels = function (clonedChannels) {
        $scope.channelsList.forEach(function(channel) {
            channel.selected = clonedChannels.includes(channel.value);
        });
    };

    var setClonedCarsCategory = function (clonedUpgradeRightCategory) {
        var carCategoryList = [
            {name: 'Economy', codes: ['E', 'H']},
            {name: 'Compact', codes: ['M', 'N', 'C', 'D']},
            {name: 'Intermediate', codes: ['I', 'J', 'S', 'R']},
            {name: 'Fullsize', codes: ['F', 'G']},
            {name: 'Premium', codes: ['P', 'U', 'L', 'W']},
            {name: 'Special', codes: ['O', 'X']},
            
        ];
        var clonedRightCategory;
        var clonedCategoryIndex;

        carCategoryList.forEach(function (category) {
            if (category.codes.includes(clonedUpgradeRightCategory)) {
                clonedRightCategory = category.name;
            }
        });

        for (var index in $scope.upgradeCategories) {
            if ($scope.upgradeCategories[index].right === clonedRightCategory) {
                clonedCategoryIndex = index;
            }
        }

        $scope.selectedUpgrade.current = $scope.upgradeCategories[clonedCategoryIndex];
    };

    var setClonedCarsSelection = function (clonedUpgradedCars) {
        var upgradeListLeft = $scope.carsList[$scope.selectedUpgrade.current.left];
        var clonedUpgradedCarsLeftOids = clonedUpgradedCars.left.map(function (car) {return car.oid});
        
        $scope.activeUpgrade.selected = clonedUpgradedCars.right.oid;
        
        upgradeListLeft.forEach(function (car) {
            car.selected = clonedUpgradedCarsLeftOids.includes(car.oid);
        });
    };

    var setClonedActiveSection = function (clonedUpgradedCars) {
        var upgradeListLeft = $scope.carsList[$scope.selectedUpgrade.current.left];
        var upgradeListRight = $scope.carsList[$scope.selectedUpgrade.current.right];
        var firstElementIndexLeft = upgradeListLeft 
            .findIndex(function (element) {return element.oid === clonedUpgradedCars.left[0].oid});
        var firstElementIndexRight = upgradeListRight 
            .findIndex(function (element) {return element.oid === clonedUpgradedCars.right.oid});
        var activeSectionIdLeft = Math.ceil((firstElementIndexLeft+1) / sectionSize);
        var activeSectionIdRight = Math.ceil((firstElementIndexRight+1) / sectionSize);

        $scope.changeActiveSection('left', activeSectionIdLeft);
        $scope.changeActiveSection('right', activeSectionIdRight);
    };

    var getCarUpgrades = function () {
        $scope.showProgressBar();
        
        fleetUpgradeService.fetchUpgradables($scope.companyOid)
            .then(function (response) {
                $scope.carsList = response.Cars;
                $scope.upgradeCategories = response.CategoriesAllow;
                $scope.selectedUpgrade.current = $scope.upgradeCategories[0];
                $scope.specialOffer.validityPeriod = dateService.periodToDate(response.validityPeriod);
                $scope.specialOffer.bookingWindow = dateService.periodToDate(response.bookingWindow);
                $scope.dividedSection = {
                    left: getDividedSection('left', 1),
                    right: getDividedSection('right', 1)
                };

                updateCarouselViewStatus();
                getDotsQty('left');
                getDotsQty('right');  

                $scope.hideProgressBar();   
            }, 
            function (error) {
                console.error('Error while trying to get Cars.', error);
                $scope.hideProgressBar();
            });
    };

    var getPointsOfSale = function(callback) {
        function getPointsOfSale() {
            pointOfSaleService.resource.query({companyOid: $scope.companyOid}, function (pointsOfSale) {
                var pointsOfSaleOid = _.map($scope.specialOffer.pointsOfSale, 'oid');
                $scope.pointsOfSaleSelector = pointOfSaleService.getPointsOfSaleSelectorConfig(pointsOfSale, pointsOfSaleOid);
            });
        }
        if(callback){callback.call();}
        getPointsOfSale();
    }

    var getSites = function () { 
        sitesService.query({}, function (response) {
            var sitesOid = _.map($scope.specialOffer.sites, 'oid');
            
            $scope.sitesResponse = response;
            $scope.sitesSelector = getSitesSelectorConfig($scope.sitesResponse, sitesOid);

            $scope.hideProgressBar();
        });
    };

    var getSitesSelectorConfig = function (sitesResponse, selectedSites) {
        var nameGenerator = function (site) {
            return site.description != 'OtherCountries'?  site.description : $translate.instant('specialOffers.site.OtherCountries');
        };

        var countryItems = itemSelectorService.getItemsForSelector(sitesResponse, selectedSites, nameGenerator);

        return itemSelectorService.newItemSelectorBuilder()
            .listOfItemsTitle('specialOffer.countrySelector.listOfItemsTitle')
            .listOfSelectedItemsTitle('specialOffers.countrySelector.listOfSelectedItemsTitle')
            .items(countryItems)
            .build();
    };

    var toObject = function (oid) {
        return {
            'oid': oid
        };
    }

    var isListEmpty = function (listPosition) {
        var emptyList = true;
 
        if(!(isEmptyObject($scope.selectedUpgrade.current) || isEmptyObject($scope.carsList))) {
            emptyList = $scope.carsList[$scope.selectedUpgrade.current[listPosition]]
            .filter(function (car) {return car.selected})
            .length === 0;
        }

        return emptyList;
    };

    var isEmptyObject = function (obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    };

    $scope.getComponentClasses = function (specialofferComponent, isCarSelected, isDotActive, fieldName) {
        var specialOfferClasses = {
            message: {
                'eva-3-message': true,
                '-no-title -info-secondary -collapsible': true,
                'specialoffer-upgrade-message': true,
                '-active': $scope.isBriefingExpanded
            },
            bookingWindow: {
                'select-tag': true,
                'input-error-noshadow': ($scope.errorField) ? $scope.errorField[fieldName] : false
            },
            purchaseWindow: {
                'specialoffer-purchase-window-disabled': !$scope.isPurchaseWindowEnabled
            },
            carCard: {
                'eva-3-card': true,
                'specialoffer-upgrade-car-card': true,
                '-card-outline': true,
                '-selected': isCarSelected
            },
            carCardRadioBtn: {
                'eva-3-card': true,
                'specialoffer-upgrade-car-card': true,
                '-card-outline': true,
                '-selected': ($scope.activeUpgrade.selected) ? (isCarSelected === $scope.activeUpgrade.selected) : false
            },
            sectionDots: {
                'nav-dot': true,
                '-active': isDotActive
            },
            specialofferName: {
                'input-tag': true,
                'input-error-noshadow': ($scope.errorField) ? $scope.errorField[fieldName] : false
            },
            channelsCheckbox: {
                'eva-3-checkbox -md': true,
                '-invalid': ($scope.errorField) ? $scope.errorField[fieldName] : false
            },
            carUpgradeRadioBtn: {
                'radio-circle': true,
                'input-error-noshadow': ($scope.errorField) ? $scope.errorField[specialofferComponent] : false
            },
            carUpgradeCheckbox: {
                'eva-3-checkbox -md': true,
                'specialoffer-upgrade-checkbox-car': true,
                '-invalid': ($scope.errorField) ? $scope.errorField[specialofferComponent] : false
            }
        };

        return specialOfferClasses[specialofferComponent];
    };

    $scope.getSelectBtnClasses = function () {
        return {
            'eva-3-btn -md -link -ghost-button': true,
            'selection-panel-operations-base': true,
            '-disabled': isListEmpty('left')
        };
    };

    $scope.getUnselectBtnClasses = function (upgradePosition) {
        return {
            'eva-3-btn -md -link -ghost-button': true,
            'selection-panel-operations-base': true,
            '-disabled': isListEmpty(upgradePosition)
        };
    };

    $scope.getUpgradeAllowedText = function (upgradeAllowed) {
        return $translate.instant('specialOffers_upgrade_' + upgradeAllowed.left + '_' + upgradeAllowed.right);
    };

    $scope.getUpgradeAllowedTextCategory = function (upgrade, leftOrRight) {
        var firstWordPosition = 0;
        var lastWordPosition = 2;
        var upgradeTextArray = $scope.getUpgradeAllowedText(upgrade).split(' ');
        
        return upgradeTextArray[(leftOrRight === 'left') ? firstWordPosition : lastWordPosition];
    };

    $scope.modifyReservationDays = function (dayType, modificationType) {
        if(modificationType === $scope.modificateDayType.ADD && $scope.specialOffer[dayType] < 30) {
            $scope.specialOffer[dayType] += 1;
        } else if (modificationType === $scope.modificateDayType.SUBSTRACT && $scope.specialOffer[dayType] > 1) {
            $scope.specialOffer[dayType] -= 1;
        }
    };

    $scope.goToSpecialOfferList = function () {
        $location.path(specialOfferUrlsService.homeOffersUrl($scope.companyOid)).search({});
    }

    var getSelectedChannels = function () {
        return $scope.channelsList.reduce(function (acum, channel) {
            if (channel.selected) acum.push(channel.value);
            return acum;
        }, [])
    };

  /*Form Validations*/

    function handleError(responseError) {
        if (responseError.data && responseError.data.params) {
            $scope.responseErrorMessage = responseError.data.message;
            $scope.responseErrorParams = responseError.data.params;
        } else {
            $scope.validationErrors = responseError.data;
        }
        document.getElementById('error-message-container').scrollIntoView();
    }

    function isValidForm() {
        var isValid = true;
        $scope.validationErrors = [];

        if (!_.some($scope.pointsOfSaleSelector.getSelectedItemsOid())) {
            isValid = false;
            $scope.errorField['pointsOfSale'] = 'input-error';
        }

        if ($scope.isInternational && !_.some($scope.sitesSelector.getSelectedItemsOid())) {
            isValid = false;
            $scope.errorField['sites'] = 'input-error';
        }

        if (!getSelectedChannels().length > 0) {
            isValid = false;
            $scope.errorField['channels'] = 'input-error';
        }

        if(isListEmpty('left')) {
            isValid = false;
            $scope.errorField['carUpgradeCheckbox'] = 'input-error';
        }

        if(!($scope.isUpgradeToDisabled || $scope.activeUpgrade.selected)) {
            isValid = false;
            $scope.errorField['carUpgradeRadioBtn'] = 'input-error';
        }

        if ($scope.specialOffer.bookingWindow) {
            var period = $scope.specialOffer.bookingWindow;
            if (!dateService.isValidFromDate(period)) {
                isValid = false;
                $scope.errorField['bookingWindow'] = 'input-error';
                $scope.validationErrors.push('specialOffers.errors.bookingWindow.invalidFromDate');
            }
            if (!dateService.isValidToDate(period)) {
                isValid = false;
                $scope.errorField['bookingWindow'] = 'input-error';
                $scope.validationErrors.push('specialOffers.errors.bookingWindow.invalidToDate');
            }
            if($scope.specialOffer.validityPeriod) {
                var validity = $scope.specialOffer.validityPeriod;
                if(period.to > validity.to) {
                    isValid = false;
                    $scope.errorField['bookingWindow'] = 'input-error';
                    $scope.validationErrors.push('specialOffers.errors.bookingWindow.validity');
                }
            }
        }

        if ($scope.specialOffer.validityPeriod) {
            var period = $scope.specialOffer.validityPeriod;
            if (!dateService.isValidFromDate(period)) {
                isValid = false;
                $scope.errorField['validityPeriod'] = 'input-error';
                $scope.validationErrors.push('specialOffers.errors.validityPeriod.invalidFromDate');
            }
            if (!dateService.isValidToDate(period)) {
                isValid = false;
                $scope.errorField['validityPeriod'] = 'input-error';
                $scope.validationErrors.push('specialOffers.errors.validityPeriod.invalidToDate');
            }
        }

        if ($scope.isBookingWindowEnabled && !$scope.specialOffer.minBookedDays) {
            isValid = false;
            $scope.errorField['minBookedDays'] = 'input-error';
        }

        if ($scope.isBookingWindowEnabled && !$scope.specialOffer.maxBookedDays) {
            isValid = false;
            $scope.errorField['maxBookedDays'] = 'input-error';
        }

        if ($scope.isBookingWindowEnabled && ($scope.specialOffer.minBookedDays > $scope.specialOffer.maxBookedDays)) {
            isValid = false;
            $scope.errorField['maxBookedDays'] = 'input-error';
            $scope.validationErrors.push('specialOffers.errors.bookingLength.invalidMaxValue');
        }

        if ($scope.specialOfferForm.$error.date) {
            var fieldNames = [];
            for (var i in $scope.specialOfferForm.$error.date) {
                fieldNames.push($scope.specialOfferForm.$error.date[i].$name);
            }
            var invalidValidityPeriod = _.includes(fieldNames, 'validityPeriod-to') || _.includes(fieldNames, 'validityPeriod-from');
            var invalidBookingWindow = _.includes(fieldNames, 'bookingWindow-to') || _.includes(fieldNames, 'bookingWindow-from');

            if (invalidValidityPeriod || invalidBookingWindow) {
                isValid = false;
                $scope.validationErrors.push('common.INVALID_DATE');

                if (invalidValidityPeriod) {
                    $scope.errorField['validityPeriod'] = 'input-error';
                }

                if (invalidBookingWindow) {
                    $scope.errorField['bookingWindow'] = 'input-error';
                }
            }
        }

        return isValid;
    }

    function checkRequiredFields(requiredFields) {
        return requiredFields.reduce((req1, req2)=> req1 || req2);
    }

    function notifyFormErrors(errors) {
        var carsNotSelected = !!($scope.errorField.cars);
        var posNotSelected = !!($scope.errorField.pointsOfSale);
        var sitesNotSelected = !!($scope.errorField.sites);
        var channelsNotSelected = !!($scope.errorField.channels);
        var upgradeLeftNotSelected = !!($scope.errorField.upgrade);
        var upgradeRightNotSelected = !!($scope.errorField['eva-radio']);
        var hasRequiredError = !!(errors) && errors.required && errors.required.length;
        var requiredFields = [
            carsNotSelected,
            posNotSelected,
            sitesNotSelected,
            channelsNotSelected,
            upgradeLeftNotSelected,
            upgradeRightNotSelected
        ];

        if (hasRequiredError || checkRequiredFields(requiredFields)) {
            $scope.validationErrors.push('specialOffers.validations.completeRequiredFields');
        }
        if (errors && errors.invalidAmountFormat) {
            $scope.validationErrors.push('warning.invalidNumberFormat');
        }

        document.getElementById('error-message-container').scrollIntoView();
    }

    var clearErrorMessages = function () {
        $scope.errorField = {};
        $scope.responseErrorMessage = null;
        $scope.responseErrorParams = null;
    };

    var notifyGA = function (category, action, tags) {
        gaService.notify(category, action, tags);
    };

    $scope.updateValidation = function (field) {
        if ($scope.errorField && $scope.errorField[field]) {
            $scope.errorField[field] = null;
        }
    };
  /*Form Validations*/

    $scope.saveUpgrade = function () {
        var deferred = $q.defer();
        clearErrorMessages();
        $scope.showProgressBar();
        
        if (isValidForm() && $scope.specialOfferForm.$valid) {
            var specialofferBody = {
                name: $scope.specialOffer.name,
                validityPeriod: {
                    from: $scope.specialOffer.validityPeriod.from,
                    to: $scope.specialOffer.validityPeriod.to
                },
                minBookedDays: ($scope.isBookingWindowEnabled) ? $scope.specialOffer.minBookedDays : 1,
                maxBookedDays: ($scope.isBookingWindowEnabled) ? $scope.specialOffer.maxBookedDays : 30,
                cars: $scope.carsList[$scope.selectedUpgrade.current.left].reduce(function (acum, car) {
                    if (car.selected) acum.push({oid: car.oid.toString()});
                    return acum;
                }, []),
                pointsOfSale: $scope.specialOffer.sites = _.map($scope.pointsOfSaleSelector.getSelectedItemsOid(), toObject),
                channels: getSelectedChannels(),
                companyOid: $scope.companyOid,
                specialOfferType: 'UPGRADE_CAR',
                isInternational: $scope.isInternational,
                upgradeCar: {oid: $scope.activeUpgrade.selected}
            };
    
            if ($scope.isInternational) {
                specialofferBody.sites = _.map($scope.sitesSelector.getSelectedItemsOid(), toObject);
            }
    
            if ($scope.isPurchaseWindowEnabled) {
                specialofferBody.bookingWindow = $scope.specialOffer.bookingWindow;
            }

            specialOfferService.save($scope.companyOid, specialofferBody)
                .then(function (response) {
                    deferred.resolve();
                    notificationService.displayToast('specialOffers.toast.createdOfferTitle', 'specialOffers.toast.createdOfferMessage', {'name': $scope.specialOffer.name});
                    $scope.hideProgressBar();
                    hotjarService.triggerStockSurvey(specialofferBody);
                    $scope.goToSpecialOfferList();
                }, function (error) {
                    deferred.reject();
                    handleError(error);
                    $scope.hideProgressBar();
                });
        } else {
            deferred.reject();
            
            for (i in $scope.specialOfferForm.$error.required) {
                $scope.errorField[$scope.specialOfferForm.$error.required[i].$name] = 'input-error';
            }

            $scope.hideProgressBar();
            notifyFormErrors($scope.specialOfferForm.$error);
        }

        return deferred.promise;        
    };

    $scope.cancelUpgrade = function () {
        $scope.showModal('CANCEL_ALERT_TITLE', 'CANCEL_ALERT_DESCRIPTION', function () {
            $scope.goToSpecialOfferList();
        });
    };

    $scope.initialize();
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/special_offer_upgrade_controller.js
// module id = 909
// module chunks = 3